import { FaIcon } from "./FaIcon";

export const EmbedSlider: FaIcon.Icon = {
  icon: [300, 300, [], "", "M150 20 h130 v260 h-130 z"]
};
